var r,t;function n(){return t?r:(t=1,r=function(r){try{return!!r()}catch(r){return!0}})}export{n as __require};
//# sourceMappingURL=fails.js.map
